import React, { useCallback } from 'react';
import { Box } from '@atlaskit/primitives/compiled';
import { UniversalCreateButtonLazy } from '@atlassian/universal-create/button/lazy';

import { useIntl } from '@atlassian/jira-intl';

import { NavigationCreateIssueButtonWrapperNudgeAsync } from '@atlassian/jira-software-onboarding-nudges--next/src/ui/navigation-create-issue/async.tsx';
import { TopLevelErrorBoundary } from '@atlassian/jira-navigation-apps-topnav4-common/src/ui/error-boundary/index.tsx';

import messages from './messages.tsx';
import {
	GLOBAL_CREATE_BUTTON_NAV4,
	GLOBAL_CREATE_BUTTON_WRAPPER,
	UNIVERSAL_CREATE_BUTTON_ID,
} from './constants.tsx';

function Create() {
	const { formatMessage } = useIntl();

	const onTriggerButtonClick = useCallback(() => {
		// TODO: add main button trigger once design is confirmed
	}, []);

	if (__SERVER__) {
		return (
			<Box testId={`${GLOBAL_CREATE_BUTTON_WRAPPER}-server-side`}>
				<UniversalCreateButtonLazy
					product="jira"
					items={[]} // don't need any items for ssr before hydration
					testId={GLOBAL_CREATE_BUTTON_NAV4}
				>
					{formatMessage(messages.create)}
				</UniversalCreateButtonLazy>
			</Box>
		);
	}

	// TODO: add actual items once confirmed
	// const items = [];

	return (
		<Box testId={`${GLOBAL_CREATE_BUTTON_WRAPPER}-client-side`}>
			<NavigationCreateIssueButtonWrapperNudgeAsync>
				<UniversalCreateButtonLazy
					product="jira"
					onClick={onTriggerButtonClick}
					items={[]}
					testId={GLOBAL_CREATE_BUTTON_NAV4}
				>
					{formatMessage(messages.create)}
				</UniversalCreateButtonLazy>
			</NavigationCreateIssueButtonWrapperNudgeAsync>
		</Box>
	);
}

export function UniversalCreate() {
	return (
		<TopLevelErrorBoundary id={UNIVERSAL_CREATE_BUTTON_ID}>
			<Create />
		</TopLevelErrorBoundary>
	);
}
